import { currencyFormatRp } from 'helpers/currency'

export const REGULAR_PAYSLIP_HEADER = {
  title: 'Regular Payslip Preview',
  lastUpdated: '01 January 2025, 01:00',
}

export const DAYS_ROWS = [
  {
    role: 'Roles 1',
    ontimeDays: 0,
    lateLt15Days: 0,
    lateGt15Days: 0,
    workDays: 0,
    leaveDays: 0,
    overtime2To4: 0,
    overtime4Plus: 0,
    overtimeHO: 0,
    overtimeHO2: 0,
  },
  {
    role: 'Roles 2',
    ontimeDays: 0,
    lateLt15Days: 0,
    lateGt15Days: 0,
    workDays: 0,
    leaveDays: 0,
    overtime2To4: 0,
    overtime4Plus: 0,
    overtimeHO: 0,
    overtimeHO2: 0,
  },
  {
    role: 'Roles 3',
    ontimeDays: 0,
    lateLt15Days: 0,
    lateGt15Days: 0,
    workDays: 0,
    leaveDays: 0,
    overtime2To4: 0,
    overtime4Plus: 0,
    overtimeHO: 0,
    overtimeHO2: 0,
  },
  {
    role: 'Roles 4',
    ontimeDays: 0,
    lateLt15Days: 0,
    lateGt15Days: 0,
    workDays: 0,
    leaveDays: 0,
    overtime2To4: 0,
    overtime4Plus: 0,
    overtimeHO: 0,
    overtimeHO2: 0,
  },
] as const

export const INCOME_ROWS = [
  {
    role: 'Roles 1',
    dailyCommission: 0,
    leaveCommission: 0,
    overtime2To4: 0,
    overtime4Plus: 0,
    overtimeHO: 0,
    overtimeHO2: 0,
  },
  {
    role: 'Roles 2',
    dailyCommission: 0,
    leaveCommission: 0,
    overtime2To4: 0,
    overtime4Plus: 0,
    overtimeHO: 0,
    overtimeHO2: 0,
  },
  {
    role: 'Roles 3',
    dailyCommission: 0,
    leaveCommission: 0,
    overtime2To4: 0,
    overtime4Plus: 0,
    overtimeHO: 0,
    overtimeHO2: 0,
  },
  {
    role: 'Roles 4',
    dailyCommission: 0,
    leaveCommission: 0,
    overtime2To4: 0,
    overtime4Plus: 0,
    overtimeHO: 0,
    overtimeHO2: 0,
  },
].map((row) => ({
  ...row,
  dailyCommissionFormatted: currencyFormatRp(row.dailyCommission),
  leaveCommissionFormatted: currencyFormatRp(row.leaveCommission),
  overtime2To4Formatted: currencyFormatRp(row.overtime2To4),
  overtime4PlusFormatted: currencyFormatRp(row.overtime4Plus),
  overtimeHOFormatted: currencyFormatRp(row.overtimeHO),
  overtimeHO2Formatted: currencyFormatRp(row.overtimeHO2),
}))
